import { Component, EventEmitter, Input, OnInit, Output, ViewChild  } from '@angular/core';
import { NavController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';
import { Storage } from '@ionic/storage'
import { ProductosProvider } from '../../providers/productos/productos';
@Component({
  selector: 'productorapidocajavertical',
  templateUrl: 'productorapidocajavertical.html',
  providers: [ UtilsProvider ]
    })

export class ProductorapidocajaverticalComponent   implements OnInit {
  elements: Array<{ type: string, id: string }> = [];
  shortcuts: any = {}; // Almacena los shortcuts configurados por página
  currentPage: string = '';
  isModalOpen: boolean = false; // Estado para controlar si el modal está abierto o cerrado
  public formState: string = 'collapsed'
  public formStateDescripcion: string = 'collapsed'
  public formStatebool:boolean= false
  public formStateboolDescripcion:boolean= false
  @Input() codigoProducto: any;
  nombreProducto
  valorVenta
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId
  productoId
  listaGrupos
  CheckCredito:boolean = false
  CheckImprimir:boolean = false
  datosCredito = []
  ventasDiarias = []
  valorImpuestosIndividual:number=0
  valorProductoIndividual :number=0
  allItems: any;
  buscar: any = "";
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  listaABC = []
  imagenImprimir:boolean = false
  token:string
  element: HTMLElement;
  blue:string=''
  turnosArray:any = [];
  mesaSeleccionada:any=0
  deseaImprimir: boolean = false;
  totals: { [key: number]: number } = {};
  groupedProducts: { [key: number]: any[] } = {};
  deDondeViene: any = undefined;
  formasDePagoGeneral: any = []
  assignedShortcuts: { [key: string]: string } = {};
  personalizarVenta:boolean = false
  turnoPersonalizado = 0
  formasDePagoSeGenero:boolean = false
  agrupaProductosEnCaja:boolean = false
  manejaPaginacionEnTendero:boolean = false;
  search:string = ''
  cargandoScroll:boolean = false;
  ultimoTiempoKeyup: number = null;
  entradaRapida: boolean = false;
  codigoTemporal: string = "";
  showBuscarProducto: boolean = false;
  buscarTexto:string = ""
  permitirSeleccion: boolean = true
  buscarTextoProductoRapido:string = ""
  unidad = 'UND'
  tipoImpuesto = "V"
  realizandoUnaVenta: boolean = false
  clienteId = []
  clienteGenerico

  listaMuestra = []
  valormesa = 0
  datosAdicionales:any
  listaDenominaciones = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerCodigoBarra;
  timerVal;
  tipoproducto = 'P';
  showCrearProducto:boolean = false
  cantidadRealCodigoBarra:number = 0
  public picture;
  public codigoBarra:any =""
  manejaCodigoDeBarras: boolean = false
  @ViewChild('cantidadafnprueba') cantidadafnprueba
  constructor(private navCtrl: NavController, public utils:UtilsProvider,
    private storage: Storage,public servicioProductos:ProductosProvider,
  ) {

  }

  toggleConfigModal() {
    this.isModalOpen = !this.isModalOpen; // Cambia el estado del modal (abrir/cerrar)
  }

  ngOnInit() {
  }
  guardarProductoRapido(){

    if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.valorVenta !== 0){

    this.codigoBarra = this.codigoProducto
    this.storage.get('companiasId').then((val) => {
    let nombretabla = "productos";
    let datosProducto: any = {
        codigoProducto: this.codigoProducto.substring(0, 80),
        nombreProducto: this.nombreProducto,
        valorVenta: this.valorVenta,
        existenciasMinimas:0,
        existenciasActuales: 0,
        visualizaEnCaja: true,
        controlaEnInventario: true,
        tipoImpuesto:this.tipoImpuesto,
        valorImpuesto: this.valorImpuesto,
        centroDeCostosId: 1,
        imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
        codigoBarra:this.codigoBarra,
        companiasId:val,
        costo:this.costo,
        queHago: "I",
        nombreTabla: "productos",
        name: "dataDynamicCrud",
        unidad:this.unidad
      }

      if(this.tipoproducto === "E") {
        nombretabla = "productosElaborados";
        datosProducto = {
          companiasId: val,
          queHago: "I",
          nombreTabla: "productosElaborados",
          name: "dataDynamicCrud",
          productosElaboradosId:  "0",
          codigoProductoElaborado: this.codigoProducto,
          nombreProductoElaborado: this.nombreProducto,
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          estado: 0,
          prioridad: 0,
          codigoBarra:this.codigoBarra,
          unidad:this.unidad
        }
    }

      this.servicioProductos.guardarProducto(datosProducto,nombretabla)
      .subscribe(
        res => {
          let responseJson = JSON.parse(res['_body'])
          let response = ''
          if(responseJson !== undefined && responseJson.data !== undefined
            && responseJson.data.response !== undefined &&
            responseJson.data.response[0] !== undefined &&
            responseJson.data.response[0][0] !== undefined &&
            responseJson.data.response[0][0][''] !== undefined &&
            responseJson.data.response[0][0][''][1] !== undefined) {
              response = 'El código del producto que desea ingresar ya existe en la base de datos..'
              this.utils.mensajeMuestro('productos',response,"warning")
            } else {
              this.utils.mensajeMuestro('productos',"Producto guardado..","success")
            }
          this.limpiarProducto()

        },
        err => {
            this.utils.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
            this.limpiarProductoRapido()
        }
      )
    // }

    })
  }else{
    // this.mostrarMensajeAdvertencia('No se pudo guardar el producto existen campos obligatorios','Verifique')
    this.utils.mensajeMuestro('productos',"No se pudo guardar el producto existen campos obligatorios","advertencia")
    this.limpiarProductoRapido()
  }
  }

  limpiarProductoRapido(){

    this.codigoBarra =""
    this.nombreProducto = ""
    this.codigoProducto = ""
    this.valorVenta = 0
    this.costo = 0
    this.formState = 'collapsed'
    this.formStatebool = false
    this.productoId = ""
    this.cantidadRealCodigoBarra = 0
  }


  limpiarProducto(){

    this.codigoBarra =""
    this.nombreProducto = ""
    this.codigoProducto = ""
    this.valorVenta = 0
    this.costo = 0
    if(this.manejaCodigoDeBarras){
      //this.canvasNoDefinido()
      //this.canvasElement.nativeElement.style ="display:none"
    }
    this.formState = 'collapsed'
    this.formStatebool = false
    this.productoId = ""
    this.cantidadRealCodigoBarra = 0
    if(this.manejaCodigoDeBarras){
      this.startTimerCodigoDeBarras()
    }
    this.unidad = 'UND'
    this.tipoImpuesto = "V"
}

startTimerCodigoDeBarras(){
  if(this.manejaCodigoDeBarras){
    this.cantidadafnprueba.nativeElement.focus();
  }
}
toggleFormCrearProductoOpen() {
  this.showCrearProducto = true;
}
toggleFormCrearProductoClose() {
  this.showCrearProducto = false;
  this.buscarTextoProductoRapido = ""
}

crearProductoRapido() {
  this.toggleFormCrearProductoOpen();
}

buscarProducto(event) {
  this.buscarTextoProductoRapido = event.value;
}

}



// WEBPACK FOOTER //
// ./src/components/productorapidocajavertical/productorapidocajavertical.ts